// @ts-nocheck

import { BasketItemState, BasketState } from '../states/basket';
import type { MatchState } from '../states/entities/matches';
import { type BasketMode, BasketModes } from '../types/basket';
import { type Licence, Licences } from '../types/common';
import { type PromotionStatus, PromotionStatuses } from '../types/promotions';

import MatchUtils from './match';

export const getShouldEnlightOperationsDisplay = (
  licence: Licence,
  userPromotionStatus: PromotionStatus,
  didReceivedUserData: boolean,
) => {
  if (didReceivedUserData) {
    return userPromotionStatus === PromotionStatuses.DEFAULT;
  }

  return licence !== Licences.ES;
};

export const isBasketItemsStartWithinEndDate = (
  basketMode: BasketMode,
  basketItemsMatches: Array<MatchState>,
  operationEndDate?: number,
  item?: unknown,
): boolean => {
  if (basketMode === BasketModes.SIMPLE) {
    const matchKey = item?.matchId ? basketItemsMatches.findIndex((match) => match?.matchId === item?.matchId) : 0;
    return MatchUtils.isMatchStartWithin48OrEndDate(basketItemsMatches[matchKey]?.matchStart, operationEndDate);
  } else if (basketMode === BasketModes.COMBINED) {
    return basketItemsMatches.every((match) => {
      return MatchUtils.isMatchStartWithin48OrEndDate(match?.matchStart, operationEndDate);
    });
  }

  return false;
};

export const hasOtherOperationsToggled = (basket: BasketState, item?: BasketItemState) => {
  if (item) {
    return !!item.eligibleKLCollectibleId || !!item.isBoomActive || !!item.isGRActive || !!item.isMonopolyActive;
  }
  return !!basket.eligibleKLCollectibleId || !!basket.isBoomActive || !!basket.isGRActive || !!basket.isMonopolyActive;
};
